import { Link } from "react-router-dom";
import { Button } from "@/components/flexkit/Button";
import { ChevronLeft } from "lucide-react";
import { type FC } from "react";

type GroupIsSystemManagedWarningProps = {
    group: {
        name: string;
    };
};

export const GroupIsSystemManagedWarning: FC<GroupIsSystemManagedWarningProps> = ({ group }) => {
    return (
        <div className="flex flex-col items-center justify-center py-12">
            <h2 className="mb-2 text-xl font-semibold text-content-primary">System-managed group</h2>
            <p className="mb-4 max-w-md text-center text-content-secondary">
                <span className="truncate">{group.name}</span> is a system-managed group and cannot be modified.
                <br />
                System groups are populated and managed automatically.
            </p>
            <Link to="/settings/members#groups">
                <Button variant="secondary">
                    <ChevronLeft className="mr-2 size-4" />
                    Back to Groups
                </Button>
            </Link>
        </div>
    );
};
